import React, { useRef, useEffect } from 'react';
import "bootstrap-icons/font/bootstrap-icons.css"; // Import Bootstrap icons


import logo1 from "./img/Sart.png";
import logo2 from "./img/Enterkey-solution-Upscale.png";
import logo3 from "./img/Truckergig-Upscale.png";
import logo4 from "./img/Talent-turbo-internet-of-humans-logo.png";
import logo5 from "./img/New-Talentturbo-Training-logo png.png";
import logo6 from "./img/Tiipstr logo.png";
import logo7 from "./img/JM.png";
import logo8 from "./img/Setld original logo.png";
import logo9 from "./img/Transitress-logo.png";
import logo10 from "./img/SimpleGo Taxi logo.png";
import logo11 from "./img/Carbify Logo.png";

const PortfolioCompany = () => {
 
  const scrollerRef = useRef(null);

  const logos = [
      logo1,
      logo2,
      logo3,
      logo4,
      logo5,
      logo6,
      logo7,
      logo8,
      logo9,
      logo10,
      logo11
  ];

  // Clone the logos to create the infinite loop effect
  const loopedLogos = [...logos, ...logos]; // Duplicating the logos array

  return (
    <>
    <div className="monitor">
            <div className="code-line"> Our Portfolios...</div>
        </div>
      <div className="portfolio-container">

          <div className="logo-scroller" ref={scrollerRef}>
              <div className="logo-items-wrapper">
                  {loopedLogos.map((logo, index) => (
                      <div key={index} className="logo-item">
                        <img src={logo} loading="lazy" alt={`Logo ${index + 1}`} />

                      </div>
                  ))}
              </div>
          </div>
      </div>
      </>
  );

}

export default PortfolioCompany